import { Form, Link, redirect, useActionData, useFetcher, data } from "@remix-run/react";
import SignUpForm, { formSchema } from "./signupform";
import { ActionFunctionArgs, json, LoaderFunctionArgs } from "@remix-run/node";
import {createSupabaseClient} from "@/lib/supabase.server";
import { Turnstile } from '@marsidev/react-turnstile'
import metaSdk from 'facebook-nodejs-business-sdk';
import { getClientIPAddress } from "remix-utils/get-client-ip-address";
import {Button} from "@/components/ui/button"
import { useEffect, useState } from "react";
import { getURL } from "@/lib/utils";
import { useToast } from "@/hooks/use-toast";
import { captureException } from "@sentry/remix";
const verifyEndpoint = 'https://challenges.cloudflare.com/turnstile/v0/siteverify'

export async function loader({request}: LoaderFunctionArgs){
  const {supabaseClient, headers} = createSupabaseClient(request);

  const user = (await supabaseClient.auth.getUser()).data.user

  // used for diffrentiating between test key and production key
  const turnstile_key = process.env.TURNSTILE_SITE_KEY;

  if(user){
    return redirect('/')
  }

  return turnstile_key;
}

export async function action({ request }: ActionFunctionArgs) {
  const form = await request.formData();
  const { supabaseClient, headers } = createSupabaseClient(request, true);

  const signupVals = {
    firstName: form.get("firstName"),
    lastName: form.get("lastName"),
    email: form.get("email"),
    password: form.get("password"),
  };

  const captchaSecret = process.env.TURNSTILE_SECRET as string;

  // console.log(process.env.TURNSTILE_SECRET)

  const validation = formSchema.safeParse(signupVals);

  if (!validation.success) {
    console.error("error with validation: ", validation.error.flatten().fieldErrors);
    captureException(validation.error)
    return data({
      error: 'There are validation errors.', success: null
    }, {headers});
  }


  // used for turnstile captchas
  const captchaToken = form.get("captcha") as string

  if(captchaToken.length === 0){
    console.error('No captcha given.')
    captureException(validation.error)
    return data({ error: "Oops! Something went wrong!", success: null}, {headers});
  }

  console.log('the captcha token is: ', captchaToken)
  console.log(`The url is: `, getURL())


  //Verifying turnstile captchatoken
  const res = await fetch(verifyEndpoint, {
    method: 'POST',
    body: `secret=${encodeURIComponent(captchaSecret)}&response=${encodeURIComponent(captchaToken)}`,
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }
  })

  const responseData = await res.json()
  console.log('the data from verification is: ', responseData)

  if(!responseData.success){
  captureException(validation.error)
  return data({ error: "Oops! Something went wrong!", success: null}, {headers});  }


  const { error } = await supabaseClient.auth.signUp({
    email: validation.data.email,
    password: validation.data.password,
    options: {
      captchaToken,
      emailRedirectTo: getURL(),
      data: {
        name: validation.data.firstName.trim() + ' ' + validation.data.lastName.trim(),
      },
    }
  });

  if(error) {
    console.error("The error is: ", error.message)
    captureException(validation.error)
    return data({ error: "Oops! Something went wrong!", success: null}, {headers});  
  }

  return redirect(`/checkEmail?email=${validation.data.email}`)
}



export default function SignUp(){

    const fetcher = useFetcher({key: "signup"});
    const {toast} = useToast();
        
    // Trigger the toast when errors exist in the actionData
    useEffect(() => {
        if (fetcher.data && fetcher.data.data) {
          // Trigger toast only when there's an error
          toast({
            title: fetcher.data.data.success ? 'Success!' : 'Something went wrong! Please try again.',
            variant: fetcher.data.data.success ? 'success' : "destructive",
          });
        }
    }, [fetcher.data, toast]); // Only trigger when actionData changes

    
    
    return(
      <div className="flex flex-col gap-3">
        <SignUpForm/>

        <Form method="POST" action="/api/google-signin" className="w-full">
          <Button variant={"outline"} type="submit" className="flex gap-3 w-full">
            <img src="/google_icon.svg"/>
            <span>Sign up with Google</span>
          </Button>
        </Form>
        
        <span className="text-[#525353] self-center text-center text-sm mt-4">Already have an account? <Link to="../login" preventScrollReset replace className="text-[#CECFD2] text-sm">Login</Link> </span>
      </div>
             
    );
}